import {
  ButtonGroup,
  HStack,
  IconButton,
  Text,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import React, { Fragment, useRef, useState } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { getDocs } from '../../stores/slices/resources/docs/docsActions';
import {
  deleteFolder,
  getFolders,
} from '../../stores/slices/resources/folders/foldersAction';
import DeleteAlert from '../Alerts/DeleteAlert';
import FolderForm from './FolderForm';

const CurrentFolder = () => {
  const { activeFolder } = useSelector(state => state.folders);
  const { getDisclosureProps, getButtonProps } = useDisclosure();

  const disclosureProps = getDisclosureProps();
  const buttonProps = getButtonProps();
  const isHidden = disclosureProps.hidden;

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isDeleting, setIsDeleting] = useState(false);
  const cancelRef = useRef();
  const dispatch = useDispatch();
  const toast = useToast();
  const onDeleteItem = async () => {
    setIsDeleting(true);
    const res = await dispatch(deleteFolder({ id: activeFolder.id }));
    onClose();
    setIsDeleting(false);
    if (res.type === 'folders/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      await dispatch(getFolders());
      await dispatch(getDocs({ id: 0 }));
      toast({
        description: 'Folder and contents has been deleted',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };
  return (
    <Fragment>
      <HStack pl={'2'}>
        {!isHidden ? (
          <FolderForm
            {...disclosureProps}
            buttonProps={buttonProps}
            edit={activeFolder}
          />
        ) : (
          <Fragment>
            <Text>
              Current folder:{' '}
              <Text as={'span'} fontWeight="bold">
                {activeFolder.name}
              </Text>
            </Text>
            {activeFolder.id > 0 && (
              <ButtonGroup isAttached size="sm" variant={'ghost'}>
                <IconButton
                  icon={<FaEdit />}
                  color={'primary'}
                  title="Rename folder"
                  {...buttonProps}
                />
                <IconButton
                  icon={<FaTrash />}
                  colorScheme={'red'}
                  title={'Delete folder'}
                  onClick={onOpen}
                />
              </ButtonGroup>
            )}
          </Fragment>
        )}
      </HStack>
      <DeleteAlert
        isOpen={isOpen}
        cancelRef={cancelRef}
        onClose={onClose}
        isDeleting={isDeleting}
        header={'Delete folder and all its contents?'}
        body={
          "Are you sure? If you proceed with the deletion, it'll be gone forever, together with the files in it."
        }
        onDeleteItem={onDeleteItem}
      />
    </Fragment>
  );
};

export default CurrentFolder;
